
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'

import VideoList from '@/components/VideoList.vue'

export default defineComponent({
  name: 'Favorite',
  components: {
    VideoList
  },
  setup () {
    const store = useStore()
    const favorites = computed(() => store.state.favorite)

    return {
      favorites
    }
  }
})
